import React from 'react'
import SEOHead from '../components/shared/SEOHead'
import { getPageSEO } from '../utils/seoConfig'
import ViewPresentation from '../components/presentation-view/ViewPresentation'
import Navbar from '../components/shared/Navbar'

const PresentationViewPage: React.FC = () => {
  return (<>
  <SEOHead seo={getPageSEO("presentationView")} />
  <div className='overflow-hidden h-dvh'>
       <Navbar showHistoryId={true} showOrganizationProfileId={true} />
      <ViewPresentation />



      </div>
    </>
  )
}

export default PresentationViewPage
